import { AU, C_LIGHT } from '../config';

export function formatDistance(m: number): string {
  if (!isFinite(m)) return '—';
  const a = Math.abs(m);
  if (a < 1000) return `${a.toFixed(0)} m`;
  if (a < 1e6) return `${(a / 1000).toFixed(a < 1e4 ? 2 : 1)} km`;
  if (a < 0.01 * AU) return `${(a / 1000).toLocaleString('en-US', { maximumFractionDigits: 0 })} km`;
  return `${(a / AU).toFixed(a < 10 * AU ? 3 : 2)} AU`;
}

export function formatSpeed(ms: number): string {
  const a = Math.abs(ms);
  if (a < 1000) return `${a.toFixed(0)} m/s`;
  if (a < 0.05 * C_LIGHT) return `${(a / 1000).toLocaleString('en-US', { maximumFractionDigits: a < 1e5 ? 1 : 0 })} km/s`;
  return `${(a / C_LIGHT).toFixed(a < 10 * C_LIGHT ? 2 : 1)} c`;
}

export function formatDuration(s: number): string {
  if (!isFinite(s) || s <= 0) return '—';
  if (s < 60) return `${s.toFixed(0)} s`;
  if (s < 3600) return `${Math.floor(s / 60)}m ${Math.floor(s % 60)}s`;
  if (s < 86400 * 2) return `${Math.floor(s / 3600)}h ${Math.floor((s % 3600) / 60)}m`;
  return `${(s / 86400).toFixed(1)} days`;
}
